import { api } from '@/shared/api'
import { GetSubscribersDto, PaginatedResponse, SubscriberResponse } from '@synapex/shared'

export const getSubscribers = async (
    data: GetSubscribersDto & { page?: number, limit?: number }
): Promise<PaginatedResponse<SubscriberResponse>> => {
    return await api.get('/telegram/subscribers', {
        params: data,
    })
}

